import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { onAuthStateChanged, signOut, signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [claims, setClaims] = useState({});
  const [loading, setLoading] = useState(true);

  const refreshClaims = useCallback(async (user, forceRefresh = false) => {
    if (!user) {
      setClaims({});
      return {};
    }
    try {
      const tokenResult = await user.getIdTokenResult(forceRefresh);
      setClaims(tokenResult.claims || {});
      return tokenResult.claims || {};
    } catch (err) {
      console.error('Error reading custom claims:', err);
      setClaims({});
      return {};
    }
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      await refreshClaims(user);
      setLoading(false);
    });

    return unsubscribe;
  }, [refreshClaims]);

  const logout = useCallback(() => signOut(auth), []);

  const signInWithGoogle = useCallback(() => signInWithPopup(auth, googleProvider), []);

  const isMailvotesUser = claims.mailvotes === true;
  const hasDoornocAccess = claims.doornoc === true || claims.isSuperUser === true;

  const value = {
    currentUser,
    claims,
    isMailvotesUser,
    hasDoornocAccess,
    isSuperUser: claims.isSuperUser === true,
    logout,
    signInWithGoogle,
    refreshClaims
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
